import SearchForm from '@/components/SearchForm/SearchForm';
import styles from '@/styles/NoAccountFound.module.scss';
import { Order } from '@/types';
import { AlertOutlineIcon, IconButton, Typography } from '@eventbrite/marmalade';
import React from 'react';

interface NoAccountFoundPageProps {
  setCurrentPage: (
    page: 'emailVerify' | 'iDontKnowEmail' | 'ticketsFound' | 'noAccountFound' | 'ticketDetails',
  ) => void;
  emailId?: string;
  handleTicketsFound: (foundOrders: Order[]) => void;
}

const NoAccountFoundPage: React.FC<NoAccountFoundPageProps> = ({
  setCurrentPage,
  emailId,
  handleTicketsFound,
}) => {
  return (
    <div className={styles.outerContainer}>
      <div className={styles['alert-container']}>
        <div className={styles['alert-icon']}>
          <IconButton
            aria-label="Alert"
            disabled
            icon={<AlertOutlineIcon size="large" />}
            outline
          />
        </div>
        <div className={styles['text-container']}>
          <Typography variant="body-md-bold" className={styles.text}>
            No tickets found
          </Typography>
          <Typography variant="body-md" className={styles.text}>
            There are no tickets associated with {emailId}. Please complete this form to find your
            tickets.
          </Typography>
        </div>
      </div>
      <div>
        <div className={styles['heading-container']}>
          <Typography variant="body-lg-bold">Look up tickets another way</Typography>
        </div>
        <SearchForm setCurrentPage={setCurrentPage} handleTicketsFound={handleTicketsFound} />
      </div>
    </div>
  );
};

export default NoAccountFoundPage;
